import { RefreshCwIcon, XIcon } from 'lucide-react';
import { useNavigate } from 'react-router';

import { REPORT_TABS, type ReportKey } from '../types';

import { Button } from '@/components/ui/button';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

interface ReportsHeaderProps {
  isRefetchingReport: boolean;
  onRefresh: () => void;
  onSelectReport: (reportKey: ReportKey) => void;
  opportunityId?: string;
  projectName?: string;
  selectedReport: ReportKey;
  titleForCurrentPage: string;
}

const ReportsHeader = ({
  isRefetchingReport,
  onRefresh,
  onSelectReport,
  opportunityId,
  projectName,
  selectedReport,
  titleForCurrentPage
}: ReportsHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between border-b px-4 py-2">
      <div className="flex min-w-0 flex-1 items-center gap-4">
        <Tabs
          className="w-[460px]"
          onValueChange={value => {
            onSelectReport(value as ReportKey);
          }}
          value={selectedReport}
        >
          <TabsList className="h-8 w-full">
            {REPORT_TABS.map(tab => (
              <TabsTrigger
                className="cursor-pointer"
                disabled={isRefetchingReport}
                key={tab.key}
                value={tab.key}
              >
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
        <div className="flex min-w-0 items-center gap-3">
          <span className="truncate text-lg font-semibold">{projectName}</span>
          <span className="text-muted-foreground">|</span>
          <span className="text-muted-foreground truncate text-sm">
            {titleForCurrentPage || 'Current Slide Name'}
          </span>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <Button
          disabled={!opportunityId || isRefetchingReport}
          onClick={onRefresh}
          size="sm"
        >
          <RefreshCwIcon
            className={`mr-2 size-4 ${isRefetchingReport ? 'animate-spin' : ''}`}
          />
          Update Preview
        </Button>
        <Button
          aria-label="Close reports view"
          onClick={() => {
            void navigate(-1);
          }}
          size="icon"
          variant="outline"
        >
          <XIcon className="size-4" />
        </Button>
      </div>
    </div>
  );
};

export default ReportsHeader;
